export const STUDENT_APP_ORIGIN = "https://asquera.com";

export const buildStudentVideoPath = ({
  videoId,
  chapterId,
  chapterName,
  sectionId,
  sectionName,
}) => {
  const params = new URLSearchParams();
  if (videoId != null && videoId !== "") params.set("video", String(videoId));
  if (chapterId != null && chapterId !== "") {
    params.set("chapter", String(chapterId));
  }
  if (chapterName) params.set("name", chapterName);
  if (sectionId != null && sectionId !== "") {
    params.set("section", String(sectionId));
  }
  if (sectionName) params.set("sectionName", sectionName);
  const query = params.toString();
  return `/video/${videoId}${query ? `?${query}` : ""}`;
};

export const buildStudentVideoUrl = (args) =>
  `${STUDENT_APP_ORIGIN}${buildStudentVideoPath(args)}`;
